import { 
    AsyncValidatorFn,
    FormControl,
    ValidationErrors
} from "@angular/forms";

import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { AuthService } from "src/app/services/auth.service";
import { UsuariosService } from "src/app/services/usuarios.service";


export const emailAlreadyExist = (
    userService: UsuariosService,
    authService: AuthService
): AsyncValidatorFn => {
    return (control: FormControl): Observable<ValidationErrors | null> => {

        return userService.obtenerUsuario(
            control.value,
            authService.obtenerSubdominio()
        ).pipe(
            map((data) => {
                return !!data && data.status == 1
                    ? { emailAlreadyExist: true }
                    : null;
            }),
            catchError((error: any) => {
                if (error.status === 409) {
                    return of(null);
                }
            })
        );
    };
};